module.exports = __webpack_public_path__ + "static/opensource-a555711d70195132d4419a4f9ddaf7c4.png";